import type { ShareAction } from '#src/app/shared/hooks/share';

import type { ShareButtonConfig, ShareVariant, TranslateLabel } from './shareButtonConfig';
import { SHARE_BUTTON_CONFIG } from './shareButtonConfig';
import type { ShareChannel as PageShareChannel } from './types';

export type ShareActionItem = Readonly<{
	ShareAction: ShareAction['ShareAction'];
	channel: PageShareChannel;
	icon: React.ReactElement;
	label: TranslateLabel;
	variant?: ShareVariant;
	successLabel?: TranslateLabel;
	secondaryLabel?: TranslateLabel;
	url: string;
	/** The URL the share action uses, when it differs from `url`. */
	shortUrl?: string;
}>;

type ShareButtonConfigOverride = Readonly<Partial<Pick<ShareButtonConfig, 'icon' | 'variant'>>>;

type Result = readonly ShareActionItem[];

function isPageShareAction(action: ShareAction): action is ShareAction {
	return action.channel in SHARE_BUTTON_CONFIG;
}

export function mapButtonConfigs(
	shareActions: readonly ShareAction[],
	overrides?: Readonly<Partial<Record<PageShareChannel, ShareButtonConfigOverride>>>,
): Result {
	return shareActions.filter(isPageShareAction).map(({ ShareAction, channel, url, shortUrl }) => ({
		ShareAction,
		channel,
		url,
		shortUrl,
		...SHARE_BUTTON_CONFIG[channel],
		...overrides?.[channel],
	}));
}
